import classNames from 'classnames';
import React from 'react';

import {
    BrowseNavigationItemSelected,
    BrowseNavigationItemStyle,
    BrowseNavigationItemType,
} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {RelatedCategoryItem} from '@udemy/react-recommendations';
import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './related-category-links.module.less';

export interface RelatedCategoryLinksProps {
    topicTitle: string;
    className?: string;
    isMobile?: boolean;
    relatedCategoriesAndSubcategories?: RelatedCategoryItem[];
}

export const RelatedCategoryLinks = ({
    topicTitle,
    className,
    isMobile,
    relatedCategoriesAndSubcategories,
}: RelatedCategoryLinksProps) => {
    const {gettext, interpolate} = useI18n();

    if (relatedCategoriesAndSubcategories?.length === 0) {
        return null;
    }

    const trackCategoryItemClick = (item: RelatedCategoryItem): void => {
        const relatedEntityId = item.id;
        const relatedEntityType = BrowseNavigationItemType.CATEGORY;

        Tracker.publishEvent(
            new BrowseNavigationItemSelected({
                id: String(relatedEntityId),
                relatedEntityId,
                type: relatedEntityType,
                relatedEntityType,
                style: BrowseNavigationItemStyle.LINK,
                uiRegion: 'related_categories_unit',
            }),
        );
    };

    const CategoryItems: React.FC<{items: RelatedCategoryItem[]}> = ({items}) => (
        <>
            {items.slice(0, 2).map((item) => (
                <a
                    href={item.url}
                    key={item.id}
                    className={styles['item-link']}
                    onClick={() => trackCategoryItemClick(item)}
                >
                    {item.title}
                </a>
            ))}
        </>
    );

    return (
        <h2
            className={classNames(
                styles['related-categories'],
                isMobile ? 'ud-heading-sm' : 'ud-heading-md',
                className,
            )}
        >
            {interpolate(gettext('%(topicTitle)s relates to '), {topicTitle}, true)}
            {relatedCategoriesAndSubcategories ? (
                <CategoryItems items={relatedCategoriesAndSubcategories} />
            ) : (
                <>
                    <BlockSkeleton />
                    <BlockSkeleton />
                </>
            )}
        </h2>
    );
};
